<template>
    <el-container>
        <el-aside class="aside-classify-tree">
            <el-header>
                <div class="title">
                    <div class="tag"></div>
                    <span class="content">{{ $t('workFlowLabelGroup.LABEL_GROUP_MANAGE') }}</span>
                </div>
            </el-header>
            <el-main style="height:auto">
                <!-- 加载扩展组列表-->
                <td-single-list
                    class="expandedGroup"
                    ref="labelGroupList"
                    rowKey="sId"
                    :height="listHeight"
                    :hasDefaultSelection="true"
                    :hasPageMemory="true"
                    :lazyloading="true"
                    :hasAddElement="true"
                    :columnObj="columnObj"
                    @currentChange="selectionChange"
                    :operateColumn="operateColumn"
                    :hasOperational="true"
                    @addElement="addGroup"
                    :interfaceName="interfaceName"
                ></td-single-list>
            </el-main>
        </el-aside>
        <el-container>
            <el-main style="height: 100%;">
                <el-form :inline="true" :model="labelForm" ref="labelForm" class="demo-form-inline">
                    <el-form-item :label="$t('workFlowLabelGroup.KEYWORD_QUERY')">
                        <td-input placeholder="common.PLEASE_SELECT" v-model="labelForm.sName"></td-input>
                    </el-form-item>
                    <el-form-item class="paddingLeft10">
                        <td-button type="primary" @click="queryLabel">{{ $t('pgCommon.QUERY') }} </td-button>
                    </el-form-item>
                    <el-form-item>
                        <td-button v-if="addLabelBtnVisible" @click="addLabel">{{ $t('pgCommon.ADD') }} </td-button>
                    </el-form-item>
                </el-form>
                <!-- 加载表格 -->
                <el-row>
                    <el-col>
                        <td-table
                            :columns="labelColumns"
                            :hasPage="true"
                            :pageSize="pageSize"
                            :currentPage="currentPage"
                            :total="total"
                            :hasMutiSelect="false"
                            :dataSource="tableData"
                            ref="labelTable"
                        >
                        </td-table>
                    </el-col>
                </el-row>
                <!-- 加载扩展组dialog -->
                <dialogWorkFlowLabel
                    v-if="dialogLabelVisible"
                    :dialogLabelVisible="dialogLabelVisible"
                    :title="labelTitle"
                    :isAdd="labelIsAdd"
                    :editItem="editLabelItem"
                    :sLabelGroupId="labelGroupForm.sId"
                    @labelDialogClose="labelDialogClose"
                    @labelSubmit="labelSubmit"
                ></dialogWorkFlowLabel>
                <!-- 加载扩展元素dialog -->
                <dialogWorkFlowLabelGroup
                    v-if="dialogLabelGroupVisible"
                    :dialogLabelGroupVisible="dialogLabelGroupVisible"
                    :title="labelGroupTitle"
                    :isAdd="labelGroupIsAdd"
                    :editItem="editGroupItem"
                    @labelGroupDialogClose="labelGroupDialogClose"
                    @updateTableNode="updateTableNode"
                    @addTableNode="addTableNode"
                ></dialogWorkFlowLabelGroup>
            </el-main>
        </el-container>
    </el-container>
</template>
<script>
import labelGroupApi from './assets/api.js';
import dialogWorkFlowLabel from './components/dialogWorkFlowLabel.vue';
import dialogWorkFlowLabelGroup from './components/dialogWorkFlowLabelGroup.vue';
export default {
    // 初始化渲染
    components: {
        dialogWorkFlowLabel,
        dialogWorkFlowLabelGroup
    },
    mounted() {
        this.labelColumns = [
            {
                prop: 'sName',
                label: '',
                showOverflowTooltip: true
            },
            {
                prop: '',
                label: this.$t('extendCommon.OPERATE'),
                tableWidth: '100',
                align: 'center',
                render: (createElement, params) => {
                    if (this.labelGroupForm.iInitType == 0) {
                        return createElement('div', [
                            createElement(
                                'td-button',
                                {
                                    props: { type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.editLabel(params.row);
                                        }
                                    }
                                },
                                this.$t('extendCommon.EDIT')
                            ),
                            createElement(
                                'td-button',
                                {
                                    props: { type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.delLabel(params.row);
                                        }
                                    }
                                },
                                this.$t('extendCommon.DELETE')
                            )
                        ]);
                    }
                }
            }
        ];
    },
    data() {
        return {
            addLabelBtnVisible: false,
            dialogLabelVisible: false,
            dialogLabelGroupVisible: false,
            labelTitle: '',
            labelGroupTitle: '',
            labelIsAdd: true,
            labelGroupIsAdd: true,
            listHeight: window.innerHeight - 320,
            //扩展组查询接口
            interfaceName: { query: '/workFlowLabelGroup/queryLabelGroup', search: '/workFlowLabelGroup/queryLabelGroup' },
            //单列表对象
            columnObj: {
                id: 'sId',
                width: '200',
                align: 'right',
                render: (createElement, params) => {
                    return createElement('div', [createElement('p', params.row.sName), createElement('p', params.row.sRemark)]);
                }
            },
            //单列表操作项
            operateColumn: {
                width: '95',
                align: 'center',
                render: (createElement, params) => {
                    if (params.row.iInitType == 0) {
                        return createElement(
                            'div',
                            {
                                style: {
                                    'margin-top': '20px',
                                    position: 'relative',
                                    left: '15px'
                                }
                            },
                            [
                                createElement('td-button', {
                                    style: {
                                        'background-image': 'url(' + window.config.treeIcon + window.vue.$store.state.skin + '/img/tree/workFlowEdit.png' + ') ',
                                        'background-size': '15px 15px',
                                        'background-color': 'transparent',
                                        'background-repeat': 'no-repeat',
                                        height: '15px',
                                        border: 0
                                    },
                                    props: { size: 'mini' },
                                    on: {
                                        click: () => {
                                            this.editGroup(params.row);
                                        }
                                    }
                                }),
                                createElement('td-button', {
                                    style: {
                                        'background-image': 'url(' + window.config.treeIcon + window.vue.$store.state.skin + '/img/tree/workFlowDelete.png' + ') ',
                                        'background-size': '15px 15px',
                                        'background-color': 'transparent',
                                        'background-repeat': 'no-repeat',
                                        height: '15px',
                                        border: 0
                                    },
                                    props: { size: 'mini' },
                                    on: {
                                        click: () => {
                                            this.deleteGroup(params.row);
                                        }
                                    }
                                })
                            ]
                        );
                    }
                }
            },
            editLabelItem: {},
            editGroupItem: {},
            pageSize: 10, // 每页条数
            currentPage: 1, // 当前页
            total: 0, // 总条数
            tableData: [],
            labelForm: {
                sName: ''
            },
            labelColumns: [],
            labelGroupForm: {
                sId: '',
                sName: '',
                sRemark: '',
                iInitType: ''
            },
            editlabelItem: {
                sId: '',
                sName: '',
                sRemark: '',
                iInitType: '',
                sLabelGroupId: ''
            }
        };
    },
    methods: {
        //选择事件
        selectionChange(currentRow) {
            if (currentRow == null) {
                return;
            }
            this.labelGroupForm.sId = currentRow.sId;
            this.labelGroupForm.sRemark = currentRow.sRemark;
            this.labelGroupForm.iInitType = currentRow.iInitType;
            if (this.labelGroupForm.iInitType == 0) {
                this.addLabelBtnVisible = true;
            } else {
                this.addLabelBtnVisible = false;
            }
            this.labelColumns[0].label = this.labelGroupForm.sRemark;
            this.callbackQuery();
        },
        // 回调查询
        callbackQuery() {
            this.currentPage = 1;
            this.queryLabel();
        },
        //扩展组弹框关闭
        labelGroupDialogClose() {
            this.dialogLabelGroupVisible = false;
        },
        // 编辑节点回显到单列表
        updateTableNode(tableData) {
            this.$refs.labelGroupList.updateTableData('modify', tableData);
        },
        // 添加节点回显到单列表
        addTableNode(tableData) {
            this.$refs.labelGroupList.updateTableData('add', tableData);
        },
        //添加扩展组
        addGroup() {
            this.dialogLabelGroupVisible = true;
            this.labelGroupIsAdd = true;
            this.labelGroupTitle = this.$t('workFlowLabelGroup.ADD_LABEL_GROUP_TITLE');
        },
        //编辑扩展组
        editGroup(row) {
            this.dialogLabelGroupVisible = true;
            this.labelGroupIsAdd = false;
            this.labelGroupTitle = this.$t('workFlowLabelGroup.EDIT_LABEL_GROUP_TITLE');
            this.editGroupItem = row;
        },
        //删除扩展组
        deleteGroup(row) {
            this.$confirm(this.$t('workFlowLabelGroup.DELETE_INFO'), this.$t('pgCommon.TIPS'), {
                confirmButtonText: window.vue.$t('pgCommon.SURE'),
                cancelButtonText: window.vue.$t('pgCommon.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    let param = {
                        idList: [row.sId]
                    };
                    labelGroupApi.deleteLabelGroup(param, response => {
                        if (response.status !== window.vue.$common.login.RESPONSE_STATUS) {
                            return;
                        }
                        if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('/workFlowLabelGroup/deleteLabelGroup', response.data.statusMessage);
                            return;
                        }
                        this.$message({ showClose: true, message: this.$t('workFlowLabelGroup.DELETE_SUCCESS'), type: 'success' });
                        this.$refs.labelGroupList.updateTableData('delete', row.sId);
                    });
                })
                .catch(() => {});
        },
        //查询扩展元素
        queryLabel() {
            var param = {
                sLabelGroupId: this.labelGroupForm.sId,
                sName: this.labelForm.sName,
                needPage: true,
                pageSize: this.pageSize,
                pageNum: this.currentPage
            };
            labelGroupApi.queryLabelList(JSON.stringify(param), response => {
                if (response.status !== window.vue.$common.login.RESPONSE_STATUS) {
                    this.$log.error('/workFlowLabel/queryLabelList', response);
                    return;
                }
                if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('/workFlowLabel/queryLabelList', response.data.statusMessage);
                    return;
                }
                this.tableData = response.data.content;
                this.total = response.data.count;
            });
        },
        //扩展元素弹框提交
        labelSubmit() {
            this.labelDialogClose();
            this.queryLabel();
        },
        //扩展元素弹框关闭
        labelDialogClose() {
            this.dialogLabelVisible = false;
        },
        // 获取每页条数
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.queryLabel();
        },
        // 获取当前页
        currentChange(currentPage) {
            this.currentPage = currentPage;
            this.queryLabel();
        },
        addLabel() {
            this.dialogLabelVisible = true;
            this.labelIsAdd = true;
            this.labelTitle = this.$t('pgCommon.ADD') + this.labelGroupForm.sRemark + this.$t('pgCommon.VALUE');
        },
        editLabel(row) {
            this.dialogLabelVisible = true;
            this.labelIsAdd = false;
            this.labelTitle = this.$t('pgCommon.EDIT') + this.labelGroupForm.sRemark + this.$t('pgCommon.VALUE');
            this.editLabelItem = row;
        },
        delLabel(row) {
            this.$confirm(this.$t('workFlowLabelGroup.DELETE_INFO'), this.$t('pgCommon.TIPS'), {
                confirmButtonText: window.vue.$t('pgCommon.SURE'),
                cancelButtonText: window.vue.$t('pgCommon.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    let param = {
                        sId: row.sId
                    };
                    labelGroupApi.deleteLabel(param, response => {
                        if (response.status !== window.vue.$common.login.RESPONSE_STATUS) {
                            return;
                        }
                        if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('/workFlowLabel/deleteLabel', response.data.statusMessage);
                            return;
                        }
                        this.$message({ showClose: true, message: this.$t('workFlowLabelGroup.DELETE_SUCCESS'), type: 'success' });
                        this.queryLabel();
                    });
                })
                .catch(() => {});
        }
    }
};
</script>
<style scoped>
.skinTwo .aside-classify-tree {
    width: 320px !important;
}
.title {
    height: 20px;
    margin: 20px 10px 10px 0;
    display: flex;
}
.title > .tag {
    height: 16px;
    width: 3px;
    background: #10c0ff;
    margin: 3px 10px 0 0;
}
.title > .content {
    line-height: 20px;
}
.expandedGroup/deep/ .cell p {
    height: 30px;
    line-height: 30px;
    padding-left: 10px;
}
.expandedGroup >>> tbody tr td {
    border-bottom: 1px #053a60ff solid !important;
    border-right: none !important;
}
.expandedGroup >>> .el-row > .el-button {
    float: right;
}
.expandedGroup >>> .el-row > .conshow {
    width: 160px !important;
    bottom: 50px;
}
.expandedGroup >>> .el-row > .el-table {
    bottom: 50px;
}
.expandedGroup >>> .el-button + .el-button {
    margin-left: 0;
}
/deep/ .el-table:before {
    display: none;
}
</style>
